import DeltaWifiAlgorithmicLists from './DeltaWifiAlgorithmicLists';

export default DeltaWifiAlgorithmicLists;
